import { IMerchant } from "containers/management/management-types";
import { fetchJSON } from "lib/fetch";
import siteConfig from "site-config";

export interface IMerchantService {
    fetchAssortmentMerchants: () => Promise<IMerchant[]>;
}

export const merchantService: IMerchantService = {
    fetchAssortmentMerchants: (): Promise<IMerchant[]> =>
        fetchJSON(`${siteConfig.api}/api/v3.0/merchants?capability=assortments`),
};
